// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1yd5q","error":"Textarea_error__2Ob1d","readonly":"Textarea_readonly__2u_iZ","disabled":"Textarea_disabled__knIbT"};